var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('multiselect',{attrs:{"options":_vm.metrics,"multiple":true},model:{value:(_vm.selectedMetrics),callback:function ($$v) {_vm.selectedMetrics=$$v},expression:"selectedMetrics"}}),(_vm.loading)?_c('div',{staticClass:"d-flex justify-content-center"},[_c('b-spinner')],1):_c('Chart',{attrs:{"options":_vm.chartOptions}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }